// extracted by mini-css-extract-plugin
export var founder_text = "index-module--founder_text--1384c";
export var play_icon = "index-module--play_icon--5fe36";
export var video_container = "index-module--video_container--8effb";
export var video_grid = "index-module--video_grid--add5a";
export var video_wrapper = "index-module--video_wrapper--48699";
export var youtube_video_wrapper = "index-module--youtube_video_wrapper--649aa";